import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Nav.css';



function Nav() {
  return (
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark ">
      
        <h3 class="navbar-brand mb-0 h1 NavText">Student App</h3>
    </nav>
  )
}

export default Nav;
